import * as React from 'react';
import { useContext } from 'react';

export type ArticleHit = {
  objectUrl: string;
  name: string;
  lastPublishedAt: string;
};

type ArticlesRecsContextType = {
  recommendations: ArticleHit[];
  isArticlesRecsLoading: boolean;
};

const ArticlesRecommendationsContext = React.createContext<ArticlesRecsContextType | undefined>(undefined);

export const useArticlesRecommendations = () => {
  const articlesRecommendations = useContext(ArticlesRecommendationsContext);

  return articlesRecommendations;
};

export default ArticlesRecommendationsContext;
